import { createAsyncThunk } from '@reduxjs/toolkit';
import { searchService } from '../../services';
import { ISearchAction } from '../../interfaces/states/search.interface';

const getMatches = () =>
  createAsyncThunk('search/getMatches', async ({ searchTerm, source }: ISearchAction) => searchService.search(searchTerm, source));

export default {
  getMatches: getMatches(),
};
